import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import Config from 'config'

firebase.initializeApp({
  apiKey: Config.apiKey,
  authDomain: Config.authDomain,
  databaseURL: Config.databaseURL,
  projectId: Config.projectId,
})

//
// Firestore
//
const firestore = firebase.firestore()
firestore.settings({ timestampsInSnapshots: true })

export const getDBClient = () => firebase.firestore()
export const getPhotoCol = () => getDBClient().collection(Config.photoCollection)

//
// Auth
//
const provider = new firebase.auth.GoogleAuthProvider()
export const login = () => getMe() ? firebase.auth() : firebase.auth().signInWithPopup(provider)
export const getMe = (): firebase.User | null => firebase.auth().currentUser
export const amIAdmin = () => {
  const me = getMe()
  if (me) {
    return !!Config.adminUids.find(uid => uid === me.uid)
  }
  return false
}



// WEBPACK FOOTER //
// ./src/fb.ts